import FormContainer from "./ForgotPasswordContainer";

export default FormContainer;